export default __webpack_public_path__ + "static/media/illustration_caugthup.6d37f4e9.svg";